import request from '@/utils/request'

export function getPageList(data) {
  return request({
    url: 'memberAward/getPageList',
    method: 'post',
    data,
  })
}

export function save(data) {
  return request({
    url: 'memberAward/save',
    method: 'post',
    data,
  })
}

export function del(data) {
  return request({
    url: 'memberAward/Delete',
    method: 'post',
    data,
  })
}